module.exports = __webpack_public_path__ + "0e99f5697b315aa78ab1f6f1bba32118.svg";